import { useRef, useCallback, useState, useEffect } from 'react';
import videojs from 'video.js';
import { defaultMuiTheme } from '../../../../../styles/MaterialTheme';
require('videojs-contrib-quality-levels');
require('videojs-mux');
require('./VjsComponents/SettingsButton');
require('./VjsComponents/CastToTvButton');
require('./VjsComponents/TheatreLayoutButton');
require('videojs-seek-buttons');
let userActiveTimer;
let beginFadeTimer;
const usePlayer = ({ videoRef, videoSrc, muxDataKey, setPlaybackRate, posterSrc, preload, playbackRate, pausePlayer, onPlay }) => {
    const player = useRef(null);
    const [error, setError] = useState(null);
    const initPlayer = useCallback(() => {
        const windowWidth = window === null || window === void 0 ? void 0 : window.innerWidth;
        const isMobileWidth = windowWidth < defaultMuiTheme.breakpoints.width('sm');
        const playerInit = videojs(videoRef.current, {
            preload: preload !== null && preload !== void 0 ? preload : 'none',
            autoplay: false,
            controls: true,
            html5: {
                //overriding native hls controls is necessary to allow for
                //quality controls on Safari, but has not been thoroughly tested
                // should not affect Chrome or FF since they have an api to override.
                hls: {
                    overrideNative: true
                },
                nativeAudioTracks: false,
                nativeVideoTracks: false,
                vhs: {
                    withCredentials: true
                }
            }
        }, () => {
            if (posterSrc)
                playerInit.poster(posterSrc);
            playerInit.src(videoSrc);
            playerInit.mux({
                debug: false,
                data: {
                    env_key: `${muxDataKey || ''}`,
                    // Metadata
                    player_name: 'Skill Builder Player',
                    player_init_time: new Date().getTime()
                }
            });
            playerInit.settingsButton({ entries: ['subtitlesButton', 'playbackRateMenuButton'] });
            playerInit.castToTvButton({});
            playerInit.emitTapEvents();
            const seekOptionsDesktop = {
                back: 10
            };
            const seekOptionsMobile = {
                back: 10,
                forward: 10
            };
            const seekOptions = isMobileWidth ? seekOptionsMobile : seekOptionsDesktop;
            playerInit.seekButtons(seekOptions);
            const captionsButton = playerInit.controlBar.getChild('SubsCapsButton');
            if (captionsButton) {
                playerInit.controlBar.removeChild(captionsButton);
            }
        });
        const handleTapOrClick = () => {
            clearTimeout(userActiveTimer);
            clearTimeout(beginFadeTimer);
            playerInit.addClass('vjs-mobile-hide-big-play-button');
            playerInit.controlBar.removeClass('vjs-mobile-fade-out');
            playerInit.controlBar.addClass('vjs-mobile-active');
            beginFadeTimer = setTimeout(() => {
                if (!playerInit.paused()) {
                    playerInit.controlBar.addClass('vjs-mobile-fade-out');
                }
            }, 1750);
            userActiveTimer = setTimeout(() => {
                if (!playerInit.paused()) {
                    playerInit.controlBar.removeClass('vjs-mobile-active');
                }
            }, 2000);
        };
        playerInit.on('play', () => {
            if (onPlay)
                onPlay();
        });
        playerInit.on('tap', () => {
            handleTapOrClick();
        });
        playerInit.on('click', () => {
            handleTapOrClick();
        });
        playerInit.on('playbackRateChanged', (_event, args) => {
            if (setPlaybackRate) {
                setPlaybackRate(args.rate);
            }
        });
        playerInit.on('fullscreenchange', () => {
            playerInit.toggleClass('vjs-inline');
        });
        playerInit.on('error', (e) => {
            console.error('error from video player', e);
            if (setError) {
                setError(e);
            }
        });
        return playerInit;
    }, [videoRef, videoSrc, muxDataKey, setPlaybackRate, posterSrc, preload]);
    useEffect(() => {
        if (!player.current && videoSrc) {
            player.current = initPlayer();
        }
    }, [initPlayer, videoSrc]);
    useEffect(() => {
        if (!(player === null || player === void 0 ? void 0 : player.current) || !pausePlayer)
            return;
        player.current.pause();
    }, [player === null || player === void 0 ? void 0 : player.current, pausePlayer]);
    useEffect(() => {
        if ((player === null || player === void 0 ? void 0 : player.current) && playbackRate) {
            const currentPlaybackRate = player.current.playbackRate();
            if (currentPlaybackRate !== playbackRate) {
                setTimeout(() => {
                    var _a;
                    (_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.trigger('updateSelectedRate', { rate: playbackRate });
                }, 200);
            }
        }
    }, [player === null || player === void 0 ? void 0 : player.current, playbackRate]);
    return { player: player.current, error };
};
export default usePlayer;
//# sourceMappingURL=usePlayer.js.map